<template>
	<VueSlickCarousel v-bind="settings" class="container-carrousel">
		<a
			v-for="(slider, index) of slides"
			:key="index"
			class="slider-parceiros rounded-default"
			:href="slider.link"
		>
			<img
				:src="slider.tamanhos[0].nome_img"
				onerror="this.onerror=null;this.src='https://img.dpcnet.com.br/catalogo/imagem_indisponivel.jpg'"
				class="rounded-default img-responsive"
				alt=""
			/>
		</a>
		<template #prevArrow="arrowOption">
			<div class="custom-arrow">{{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}</div>
		</template>
	</VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
	name: 'Slider',
	components: { VueSlickCarousel },
	props: {
		arrows: {
			type: Boolean,
			default: true,
		},
		dots: {
			type: Boolean,
			default: true,
		},
		slides: {
			type: Array,
			default: () => [],
		},
	},
	computed: {
		settings() {
			return {
				infinite: true,
				speed: 800,
				slidesToShow: 5,
				slidesToScroll: 2,
				dots: false,
				autoplay: true,
				autoplaySpeed: 4000,
				responsive: [
					{
						breakpoint: 1199,
						settings: {
							slidesToShow: 6,
							slidesToScroll: 4,
						},
					},
					{
						breakpoint: 1024,
						settings: {
							slidesToShow: 6,
							slidesToScroll: 4,
						},
					},
					{
						breakpoint: 815,
						settings: {
							slidesToShow: 5,
							slidesToScroll: 5,
						},
					},
					{
						breakpoint: 630,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 4,
						},
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
						},
					},
					{
						breakpoint: 365,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 275,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			};
		},
	},
};
</script>
<style>
/* the slides */
.slick-slide {
	padding-right: 15px;
	overflow: hidden;
}

.container-carrousel {
	margin: 0px 20px 0px 20px;
}

/* the parent */
.slick-list {
	padding-right: -15px;
}
</style>
<style lang="scss" scoped>
@import '~@/style/Global.css';
.img-responsive {
	object-fit: scale-down;
	border-radius: 16px !important;
}

.slider-parceiros {
	display: flex !important;
	height: 100px !important;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	background-color: #fff;
}

:focus {
	outline: 0;
}
.slider-parceiros {
	z-index: 0;
}

/* EFEITO PRETO E BRANCO PARCEIROS */

.slider-parceiros img {
	transition: all 0.3s ease;
	filter: grayscale(100%);
	opacity: 0.66;
	padding: 10px;
	max-height: 90px;
}

.slider-parceiros img:hover {
	filter: none;
	opacity: 1;
}

/* END EFEITO PRETO E BRANCO PARCEIROS */
</style>

